import styled from '@emotion/styled';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: inherit;
  padding: 32px 0 12px;
`;
